import {
    ContainerMessageData,
    Content,
    ContentMessageBox,
    ContentSection,
    Section,
    SectionTitle,
    UserEmail,
    UserList, UserName
} from "./styled";
import HeaderModal from "@dropDesk/presentation/components/headers/header_modal";
import React, {useEffect, useState} from "react";
import {Brightness} from "@dropDesk/domain/entities/theme/colors.entity";
import {Watermark} from "@dropDesk/presentation/pages/ticket/ui/styled";
import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import MessageBox from "@dropDesk/presentation/components/messages/message_box";
import {UserEntity} from "@dropDesk/domain/entities/user/user.entity";
import {observer} from "mobx-react";
import {ICONS_DROPDESK} from "@dropDesk/storage/icons/icons.d";
import {ChatMessageEntity} from "@dropDesk/domain/entities/messages/message_enums";
import {ChatController} from "@dropDesk/presentation/pages/chat/controller/chat.controller";
import DropDeskLoadingDefault from "@dropDesk/presentation/components/loadings/loading_table";
import MessageDataUserItem
    from "@dropDesk/presentation/components/messages/message_box/arrow_menu_popover/modals/message_data/message_data_item";
import DropDeskIcon from "@dropDesk/storage/icons";
import {TicketMessageEntity} from "@dropDesk/domain/entities/ticket/message/ticket_message.entity";
import {InternalChatController} from "@dropDesk/presentation/pages/chat/controller/internal_chat.controller";

const MessageData = observer((
    {
        message,
        onClose,
        userClient,
        attendant,
        userLogged,
    }: {
        message: ChatMessageEntity
        onClose: () => void
        userClient: UserEntity | null
        attendant?: UserEntity,
        userLogged: UserEntity
    }
) => {
    const [loading, setLoading] = useState<boolean>(false);
    const appController = useInjection(AppController);
    const chatController = useInjection(ChatController);
    const internalChatController = useInjection(InternalChatController);
    const colors = appController.theme.colorScheme;
    const readByUsers = message instanceof TicketMessageEntity ? chatController.readByUsers : internalChatController.readByUsers;
    const receivedByUsers = message instanceof TicketMessageEntity ? chatController.receivedByUsers : internalChatController.receivedByUsers;

    useEffect(() => {
        setLoading(true);
        message instanceof TicketMessageEntity ? chatController.handleDetailMessage(message).then(() => {
            setLoading(false);
        }) : internalChatController.handleDetailMessage(message).then(() => {
            setLoading(false);
        });
    }, []);

    return (
        <ContainerMessageData>
            <HeaderModal
                disabled={false}
                letter={"Dados da mensagem"}
                nameIcon={ICONS_DROPDESK.close}
                onClick={onClose}
                background={colors.backgroundChatBox}
            />
            <Content background={colors.backgroundChatBox}>
                <Watermark
                    style={{flex: "none"}}
                    isDarkTheme={colors.brightness === Brightness.dark}
                    background={colors.backgroundChatBox}
                >
                    <ContentMessageBox>
                        <MessageBox
                            message={message}
                            useReplyButton={false}
                            onReplyClick={() => {
                            }}
                            useDeleteMessageButton={false}
                            handleDeleteMessage={() => {
                            }}
                            resetMessageFocused={() => {
                            }}
                            focus={false}
                            onReplyMessageClick={() => {
                            }}
                            onRetrySendMessageError={() => {
                            }}
                            status={message.getStatus(userClient, userLogged.role, attendant)}
                            cancelUpload={() => {
                            }}
                            handleRemoveReaction={async () => {
                            }}
                            canRemoveReaction={false}
                            useEditMessageButton={false}
                            handleEditMessage={() => {
                            }}
                            handleAddReaction={async () => {
                            }}
                            lastUsedReactions={[]}
                            isEdit={false}
                            reactions={[]}
                            showOriginalFile={() => {
                            }}
                            setLoaded={() => {
                            }}
                        />
                    </ContentMessageBox>
                </Watermark>
                <ContentSection>
                    {!loading && <Section>
                        <SectionTitle color={colors.text}>
                            <DropDeskIcon icon={ICONS_DROPDESK.doubleTick}
                                          color={colors.readMessage}
                                          size={16}/>
                            &nbsp;Lida por:
                        </SectionTitle>
                        <UserList>
                            {readByUsers.length > 0 ? (
                                readByUsers.map((user) => (
                                    <MessageDataUserItem user={user}/>
                                ))
                            ) : (
                                <UserName color={colors.hint}>Nenhum usuário leu esta mensagem</UserName>
                            )}
                        </UserList>
                    </Section>}

                    {!loading && <Section>
                        <SectionTitle color={colors.text}>
                            <DropDeskIcon icon={ICONS_DROPDESK.doubleTick}
                                          color={colors.hint}
                                          size={16}/>
                            &nbsp;Entregue para:
                        </SectionTitle>
                        <UserList>
                            {receivedByUsers.length > 0 ? (
                                receivedByUsers.map((user) => (
                                    <MessageDataUserItem user={user}/>
                                ))
                            ) : (
                                <UserName color={colors.hint}>Nenhum usuário recebeu esta mensagem</UserName>
                            )}
                        </UserList>
                    </Section>}
                    {loading &&
                        <DropDeskLoadingDefault
                            height={80}
                            description={"Carregando ..."}
                        />
                    }
                </ContentSection>
            </Content>
        </ContainerMessageData>
    )
});
export default MessageData;
